<template>
  <div>
    <!-- :class="loadViewer?'full-screen':'img-viewer'"
    {{loadViewer}} -->
    <viewer v-if="loadViewer" @inited="inited" :options="options" :images="images" class="viewer" ref="viewer">
      <img v-for="(img,index) in images" :src="img" :key="index" style="display:none;">
    </viewer>
  </div>
</template>
<script>
import { imgServer } from '@/api/common/upload'
// import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
// Vue.use(Viewer)
// Viewer.setDefaults({
//   zIndexInline: 9999
// })
Vue.use(Viewer, {
  debug: true,
  defaultOptions: {
    zIndex: 9999
  }
})

export default {
  name: 'ImageViewer',
  data() {
    return {
      options: {
        inline: false,
        button: true,
        // navbar: false,
        title: false,
        // toolbar: false,
        // tooltip: false,
        // movable: false,
        // zoomable: false,
        // rotatable: false,
        // scalable: false,
        // transition: false,
        // fullscreen: false,
        // keyboard: false,
        url: 'data-source'
      },
      loadViewer: false,
      defIndex: 0,
      images: []
    }
  },
  created() {
    //info:{ images: UnitFileData[]; index: number }
      window.eventBus.$on('showImageViewer', (info) => {
      this.loadViewer = false
      this.images = info.images.map(d => {
        var f = d.AttInfo
        return imgServer(f.Id, f.TempGuid, d.FileName)
      })
      this.defIndex = info.index
      this.loadViewer = true
    })
  },
  mounted() { },
  beforeDestroy() {
    this.loadViewer = false
    this.$viewer = null
    window.eventBus.$off('showImageViewer')
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer
      this.$viewer.view(this.defIndex)
    }
    //自定义事件 initData(){},
  }
}
</script>
<style>
.viewer-close {
  background-color: rgba(250, 0, 0, 0.5) !important;
}
</style>